import L from 'leaflet';

/**
 * Shared Leaflet basemap layer. CARTO basemaps now require an API key (tiles
 * render an "API KEY REQUIRED" placeholder), so every map goes through Mapbox
 * raster tiles via the public (pk.) VITE_MAPBOX_TOKEN. Falls back to plain
 * OpenStreetMap tiles when the token is missing so maps never render blank.
 */
export type BaseMapStyle = 'dark' | 'light' | 'streets';

const MAPBOX_STYLE_IDS: Record<BaseMapStyle, string> = {
  dark: 'dark-v11',
  light: 'light-v11',
  streets: 'streets-v12',
};

const MAPBOX_ATTRIBUTION =
  '&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

export function createBaseTileLayer(
  style: BaseMapStyle,
  options: L.TileLayerOptions = {},
): L.TileLayer {
  const token = import.meta.env.VITE_MAPBOX_TOKEN as string | undefined;

  if (!token) {
    return L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19,
      ...options,
    });
  }

  return L.tileLayer(
    `https://api.mapbox.com/styles/v1/mapbox/${MAPBOX_STYLE_IDS[style]}/tiles/512/{z}/{x}/{y}@2x?access_token=${token}`,
    {
      attribution: MAPBOX_ATTRIBUTION,
      tileSize: 512,
      zoomOffset: -1,
      maxZoom: 20,
      ...options,
    },
  );
}
